function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import { AppContext } from 'context';
import history from 'helpers/history';
import BackButton from 'components/BackButton';
import Button from 'components/Form/Button';
import Tabs from 'components/Tabs';
import urlRouteShape from 'shapes/urlRouteShape';
import App, { AlertsBus } from 'modules/App';
import { ContourCloudInfo, ExternalDataSources } from 'modules/DataSources';
import ReauthorizeContourCloudButton from 'modules/Patient/partials/ReauthorizeContourCloudButton';
import * as actions from '../../actions';
import * as selectors from '../../selectors';
import messages from '../../messages';
import ClinicsMemberships from './ClinicsMemberships';
import PatientProfile from './PatientProfile';
import ProfileSettings from './ProfileSettings';
import styles from './AccountSettings.pcss';
var _React_PureComponent;
class AccountSettings extends (_React_PureComponent = React.PureComponent) {
    onChangeView(view) {
        let url;
        if (view === 'settings') {
            url = this.context.getUrl('account-settings');
        } else {
            url = this.context.getUrl('account-settings-view', {
                view
            });
        }
        history.push(url);
    }
    get backUrl() {
        const { getUrl } = this.context;
        const { name, params } = this.props.activeProfileMainUrlRoute;
        return getUrl(name, params);
    }
    renderHeader() {
        return /*#__PURE__*/ _jsxs("header", {
            className: "pageHeader row",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col",
                    children: /*#__PURE__*/ _jsx("h1", {
                        className: "text--h1",
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.profileSettings))
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-auto",
                    children: /*#__PURE__*/ _jsx(Button, {
                        styleModifier: "primary",
                        labelMessage: messages.buttons.signOut,
                        className: "btn--filled",
                        onClick: this.props.onSignOut
                    })
                })
            ]
        });
    }
    renderView() {
        if (this.props.view === 'clinics') {
            return /*#__PURE__*/ _jsx(ClinicsMemberships, {});
        }
        if (this.props.view === 'patientProfile') {
            return /*#__PURE__*/ _jsx(PatientProfile, {});
        }
        if (this.props.view === 'dataSources') {
            return /*#__PURE__*/ _jsxs("section", {
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "mb-9",
                        children: [
                            /*#__PURE__*/ _jsx(ContourCloudInfo, {}),
                            /*#__PURE__*/ _jsx(ReauthorizeContourCloudButton, {})
                        ]
                    }),
                    /*#__PURE__*/ _jsx(ExternalDataSources, {})
                ]
            });
        }
        return /*#__PURE__*/ _jsx(ProfileSettings, {});
    }
    render() {
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx(BackButton, {
                    to: this.backUrl
                }),
                this.renderHeader(),
                /*#__PURE__*/ _jsx(AlertsBus, {
                    isGlobal: true,
                    className: "mb-8"
                }),
                /*#__PURE__*/ _jsx(Tabs, {
                    activeItem: this.props.view,
                    items: this.props.views,
                    messages: messages.nav,
                    action: (activeView)=>this.onChangeView(activeView)
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "pt-6",
                    children: this.renderView()
                })
            ]
        });
    }
}
_define_property(AccountSettings, "contextType", AppContext);
_define_property(AccountSettings, "propTypes", {
    // Explicit props
    view: PropTypes.string,
    views: PropTypes.arrayOf(PropTypes.string).isRequired,
    // Implicit props
    activeProfileMainUrlRoute: urlRouteShape,
    route: App.shapes.route,
    // Implicit actions
    onSignOut: PropTypes.func
});
const mapStateToProps = (state)=>({
        activeProfileMainUrlRoute: selectors.activeProfileMainUrlRoute(state),
        route: App.selectors.route(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onSignOut: ()=>dispatch(actions.signOut())
    });
const ConnectedAccountSettings = connect(mapStateToProps, mapDispatchToProps)(AccountSettings);
export default withStyles(styles)(ConnectedAccountSettings);
